import styled from "styled-components";
export const Dot = styled.div`
  --color: #c4c4c4;
  width: 14px;
  height: 14px;
	margin: 0 5px;
	border-radius: 50%;
  cursor: pointer;
  border: 2px solid var(--color);
  background-color: ${({ isActive }) =>
    isActive ? "var(--color)" : "transparent"};
`;
